var cwAdr = {};
cwAdr.imScrolled    = false;
cwAdr.outOfTop      = false;
cwAdr.outOfBottom   = false;
cwAdr.lastScroll    = -100;
cwAdr.searchTab     = [];
cwAdr.markers       = [];
cwAdr.lastMarker    = -1;
cwAdr.scrollPos     = 0;
cwAdr.svgComplete   = true;
cwAdr.ifMouseStoped = false;
cwAdr.timeOut;

cwAdr.googleMapsCSS = [{ "featureType": "administrative", "elementType": "all", "stylers": [{ "saturation": "-100" }] }, { "featureType": "administrative.province", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "landscape", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": 65 }, { "visibility": "on" }] }, { "featureType": "poi", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": "50" }, { "visibility": "simplified" }] }, { "featureType": "road", "elementType": "all", "stylers": [{ "saturation": "-100" }] }, { "featureType": "road.highway", "elementType": "all", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "road.arterial", "elementType": "all", "stylers": [{ "lightness": "30" }] }, { "featureType": "road.local", "elementType": "all", "stylers": [{ "lightness": "40" }] }, { "featureType": "transit", "elementType": "all", "stylers": [{ "saturation": -100 }, { "visibility": "simplified" }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "hue": "#ffff00" }, { "lightness": -25 }, { "saturation": -97 }] }, { "featureType": "water", "elementType": "labels", "stylers": [{ "lightness": -25 }, { "saturation": -100 }] }];

$(document).ready(function () {

    if($('.cwadr-this-is-page').length){
        _scrolledFix();
          
 
        $(window).scroll(function () {
            cwAdr.imScrolled = true;
        });

        setInterval(function () {
            if (cwAdr.imScrolled) {
                _scrolledFix();
                cwAdr.imScrolled = false;
            }
        }, 250);

        _checkHeaderSize();
        _checkPostHalfSize();

        $(window).resize(function () {
            _checkHeaderSize();
            _checkPostHalfSize();
        });

    }

    //Zmiana kontrastu strony
    $('#cwadr-contrast-bony').click(function(){_changeContrast('bony')});
    $('#cwadr-contrast-yonb').click(function(){_changeContrast('yonb')});
    $('#cwadr-contrast-bonw').click(function(){_changeContrast('bonw')});
    $('#cwadr-contrast-wonb').click(function(){_changeContrast('wonb')});
    $('#cwadr-contrast-default').click(function () { _changeContrast('default')});

    $('#cwadr-font-default').click(function () { _changeFont(100)});
    $('#cwadr-font-plus').click(function () { wrdPress.fontSize += 10; if (wrdPress.fontSize > 130) { wrdPress.fontSize = 130} _changeFont(wrdPress.fontSize)});
    $('#cwadr-font-minus').click(function () { wrdPress.fontSize -= 10; if (wrdPress.fontSize < 80) { wrdPress.fontSize = 80 } _changeFont(wrdPress.fontSize )});

    // Przycisk do pokazania menu mobilnego
    $('#cwadr-menu-mobile-btn').click(function(){
        $('#cwadr-mobile-menu').addClass('cwadr-mobile-menu-show');

        anime({
            targets: '#cwadr-mobile-menu',
            opacity: [0,1],
            translateX: ['20rem', '0'],
            easing: 'easeInOutQuad'
        });
    });
    // Przycisk do zamkniecia menu mobilnego
    $('.cwadr-mobile-menu-close > button').click(function(){
        anime({
            targets: '#cwadr-mobile-menu',
            opacity: [1,0],
            translateX: ['0', '-20rem' ],
            easing: 'easeInOutQuad',
            complete: function(){
                $('#cwadr-mobile-menu').removeClass('cwadr-mobile-menu-show');
            }
        });
        
    }); 

    // Menu DrillDown w Menu moblinym
    new Foundation.Drilldown(
        $('#cwadr-mobile-menu > ul'),
        {
            backButton: '<li class="js-drilldown-back"><a tabindex="0">Wróć</a></li>',
            backButtonPosition: 'bottom'
        }
    );

    // Menu dropdown w menu standardowym
    new Foundation.DropdownMenu(
        $('#cwadr-dropdown-menu'),
        {
            // disableHover: true,
            // clickOpen: true
        }
    );

    new Foundation.Reveal($('#cwadrModal'),{});
    new Foundation.Reveal($('#cwadrModal2'),{});

    new Foundation.Equalizer($('#cwadr-article-list'));

    // Akcja przy otwieraniu dropdowna w menu standardowym
    $('.cwadr-menu-dropmenu').on(
        'mouseenter', function () {
            var dropdown = $(this).find('.is-dropdown-submenu');
            dropdown.css('display', 'block');
            anime({
                targets: dropdown.get(),
                opacity: [0,1],
                translateY: ['2rem', '-2rem'],
                duration: 350,
                easing: 'easeInOutQuad'
            });
        }); 

    // Akcja przy zamykaniu dropdowna w menu standardowym
    $('.cwadr-menu-dropmenu').on(
        'mouseleave', function () {
            var dropdown = $(this).find('.is-dropdown-submenu');
            anime({
                targets: dropdown.get(),
                opacity: [1, 0],
                translateY: ['-2rem', '-4rem'],
                duration: 250,
                easing: 'easeInOutQuad',
                complete: function(){
                    dropdown.css('display', 'none');
                }
            });
        });


    // Akcja przy otwieraniu modala
    $('.cwadr-modal').on(
        'closeme.zf.reveal', function () {
            anime({
                targets: this,
                opacity: [0, 1],
                translateY: ['2rem', '-2rem'],
                duration: 350,
                easing: 'easeInOutQuad'
            });
        }); 

    // Akcja przy zamykaniu dropdowna w menu standardowym
    $('.cwadr-modal').on(
        'closed.zf.reveal', function () {
            anime({
                targets: this,
                opacity: [1, 0],
                translateY: ['-2rem', '-4rem'],
                duration: 250,
                easing: 'easeInOutQuad'
            });
        });

});


function _scrolledFix() {
    var st = $(window).scrollTop(),
        sb = st + $(window).height();

    if (Math.abs(cwAdr.lastScroll - st) <= 25)
        return;
    changeMenuUp(st);
    // AKcja będąc na odpowiednim miejscu 
    if (cwAdr.outOfBottom == false & sb > $('#cwadr-footer-top').position().top) {
        anime({
            targets: '.cwadr-fixed-bottom',
            opacity: [1, 0],
            translateY: ['0', '2rem'],
            duration: 10,
            easing: 'easeInOutQuad'
        });
        cwAdr.outOfBottom = true;
    } else if (cwAdr.outOfBottom == true & sb < $('#cwadr-footer-top').position().top){
        anime({
            targets: '.cwadr-fixed-bottom',
            opacity: [0, 1],
            translateY: ['2rem',0],
            duration: 200,
            easing: 'easeInOutQuad'
        });
        cwAdr.outOfBottom = false;
    }
    cwAdr.lastScroll = st;
}




function numberUpAnimation(cls, toValue) {
    var myValue = { prop: 0 };
    var domAttributes = anime({
        targets: myValue,
        prop: toValue,
        round: 1,
        duration: 3000,
        easing: 'easeInOutExpo',
        update: function () {
            $(cls).text(myValue.prop);
        }
    });
}

// zmiana menu gornego
function changeMenuUp(st) {
    var $menu = $('#cwadr-menu'); 
 
    if (st > 300) {
        $menu.addClass('cwadr-menu-out');
        $('.icon-scroll').fadeOut();

    } else {
        $menu.removeClass('cwadr-menu-out');
        $('.icon-scroll').fadeIn();
    }
}


function addLoader(cls){
    $(cls).html('<div class="spinner"><div class="double-bounce1" ></div><div class="double-bounce2"></div></div>');
}

function removeLoader(){
    anime({
        targets: '.spinner',
        translatey: 150,
        opacity: 0,
        duration: 1000,
        complete: function (anim) {
            if (anim.completed === true) { $('.spinner').remove(); }
        }
    });
}

function ifMobile(){
    var isMobile = false, 
        wWidth = $(window).width();
    if (wWidth < 768) { isMobile = true;}
    return isMobile;
}

function _checkHeaderSize(){
    var height = 250 + $('.cwadr-page-header-effect > h1').height() + 100;
    anime({
        targets: '.cwadr-page-header',
        height: height
    });
}

// Jeżeli jesteśmy an stronie na której jest wyświetlany post na połowie strony:
function _checkPostHalfSize(){
    if($('.cwadr-post-content-half').length > 0){
        var wHeight   = $(window).height();
        var topOffset = $('.cwadr-post-content-half').offset().top;
        var height    = wHeight - topOffset;

        $('.cwadr-post-content-half').css('height',height+'px');
        
    }
}



// Ustawienie ciasteczka
function _setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
}

// Pobranie ciasteczka
function _getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}

// Zmiana czcionki
function _changeFont(size) {
    var $body = $('body');
    $body.css('font-size', size+'%');
    _setCookie('cwadr_fontsize', size, 30);
}

// zmiana kontrastu
function _changeContrast(type) {
    var $body = $('body'),
        contrast = _getCookie('cwadr_contrast');

    $body.removeClass('cwadr-' + contrast);
    $body.removeClass('cwadr-contrast');

    if (type !== 'default') {
        $body.addClass('cwadr-' + type);
        $body.addClass('cwadr-contrast');
    }

    _setCookie('cwadr_contrast', type, 30);
}

function iAmTheCreator(){
    console.log('%cAutorem strony jest:    ' + '%c  Adrian Gazda  ', 'font-size: 14px; text-align: center', 'font-size: 20px; background: #296d8e; color: white;');
}